import React from 'react';
import * as Yup from 'yup';
import FormikField from 'components/Form/FormikField';
import FormikForm from 'components/Form/FormikForm';
import FormField from 'components/Form/FormField/FormField';
import StyledLink from 'components/MainContent/StyledLink/StyledLink';

// Grommet
import { Anchor, Box, Text } from 'grommet';

const validationSchema = Yup.object({
  firstName: Yup.string().required('Your first name is required'),
  lastName: Yup.string().required('Your last name is required'),
  emailAddress: Yup.string()
    .email('Invalid email address')
    .required('An email address is required'),
  password: Yup.string()
    .required('A password is required')
    .min(6, 'A password must be minimum 6 characters'),
});

const SignupForm = ({ onSubmit }) => {
  return (
    <>
      <FormikForm
        validationSchema={validationSchema}
        initialValues={{
          firstName: '',
          lastName: '',
          emailAddress: '',
          password: '',
        }}
        onSubmit={onSubmit}
        cancelBtn={false}
        submitText='Sign Up'
        formTitle='Create your Line-Up account'
        hasborder
        heavypadding
        headercentred
        submitfull
      >
        <FormikField
          name='firstName'
          label='First name'
          component={FormField}
          type='text'
          placeholder='Your first name'
        />
        <FormikField
          name='lastName'
          label='Last name'
          component={FormField}
          type='text'
          placeholder='Your last name'
        />
        <FormikField
          name='emailAddress'
          label='Email'
          component={FormField}
          type='email'
          placeholder='Your email address'
        />
        <FormikField
          name='password'
          label='Password'
          component={FormField}
          type='password'
          placeholder='A secure password'
        />
        <Box margin={{ top: 'small' }}>
          <Text size='small'>
            By clicking 'Sign Up', you agree to our{' '}
            <Anchor target='_blank' href={'https://lineupnow.com/terms'}>
              Terms of Service
            </Anchor>
          </Text>
        </Box>
      </FormikForm>
      <Box margin={{ top: 'medium' }}>
        <StyledLink to={'/user/login'} label='Already have an account? Login' />
      </Box>
    </>
  );
};

export default SignupForm;
